import { GET_PROCESSING_INVOICE_SKIDS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_PROCESSING_INVOICE_SKIDS:
            return action.payload;
        default:
            return state;
    }
}